import React from "react";
import { FaSearch, FaPencilRuler, FaCode, FaRocket } from "react-icons/fa";

const steps = [
  {
    step: "01",
    title: "Kuptim & planifikim",
    body: "Bisedojmë me ju për të kuptuar nevojat, afatin dhe buxhetin. Rezultati: një plan i qartë para se të fillojmë ndonjë punë.",
    icon: FaSearch,
  },
  {
    step: "02",
    title: "Dizajn & strukturë teknike",
    body: "Hartojmë rrjedhat e përdoruesit, strukturën teknike dhe fazat kryesore të projektit — kështu dimë saktësisht çfarë ndërtojmë.",
    icon: FaPencilRuler,
  },
  {
    step: "03",
    title: "Ndërtim & testim",
    body: "Ndërtojmë hap pas hapi me përditësime javore. Testojmë çdo gjë para se t'ju tregojmë rezultatin.",
    icon: FaCode,
  },
  {
    step: "04",
    title: "Lansim & mbështetje",
    body: "Publikojmë projektin, monitorojmë performancën dhe ju dorëzojmë gjithçka — kodin, dokumentimin dhe udhëzimet për ta menaxhuar vetë.",
    icon: FaRocket,
  },
];

function Process() {
  return (
    <section className="process section-pad" id="approach">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Modeli i punës</span>
          <h2>Si arrijmë rezultate të parashikueshme</h2>
          <p>
            Çdo projekt ka hapat e vet — dhe ne i ndjekim me kujdes. Klientët tanë dinë gjithmonë ku jemi dhe çfarë vjen më pas.
          </p>
        </div>

        <div className="process-grid">
          {steps.map(({ step, title, body, icon: Icon }) => (
            <article key={step} className="process-card">
              <div className="process-card-top">
                <span className="process-step">{step}</span>
                <span className="process-icon-wrap" aria-hidden="true">
                  <Icon />
                </span>
              </div>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
